<template>
    <v-dialog v-model="value" scrollable persistent max-width="300px" :fullscreen="$vuetify.breakpoint.xsOnly">
        <v-card>
            <v-toolbar dark color="primary">
                <v-toolbar-title>{{title ? title : $t('menu.teams')}}</v-toolbar-title>
                <v-spacer />
                <v-btn icon dark @click="$emit('input', false)">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-toolbar>
            <v-divider />
            <v-card-text class="v-dialog-body">
                <v-layout>
                    <v-flex xs12>
                        <v-list>
                            <template v-for="team in teams">
                                <v-list-tile
                                    v-if="team.id != getCurrentTeamId"
                                    avatar
                                    :key="team.id"
                                    @click="returnTeam(team)"
                                >
                                    <v-list-tile-avatar>
                                        <v-badge overlap bottom color="orange">
                                            <v-icon slot="badge" dark small>group</v-icon>
                                            <v-avatar color="red" size="36">
                                                <span class="white--text headline">{{getNameAlias(team.name)}}</span>
                                            </v-avatar>
                                        </v-badge>
                                    </v-list-tile-avatar>
                                    <v-list-tile-content>
                                        <v-list-tile-title class="font-weight-bold">{{team.name}}</v-list-tile-title>
                                    </v-list-tile-content>
                                </v-list-tile>
                            </template>
                        </v-list>
                    </v-flex>
                </v-layout>
<!--                <v-layout v-if="loading" text-xs-center>-->
<!--                    <v-flex xs12>-->
<!--                        <v-progress-circular indeterminate color="primary" />-->
<!--                    </v-flex>-->
<!--                </v-layout>-->
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn color="blue darken-1" flat @click="$emit('input', false)">{{$t('action.cancel')}}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager"
    import axios from 'axios'

    export default {
        props: {
            value: Boolean,
            title: String
        },
        data() {
            return {
                bottomReached: false,
                page: 1,
                // loading: true,
                teams: [],
                searching: false,
                cancel: () => {}
            }
        },
        watch: {
            value: function(newValue) {
                if(newValue){
                    this.bottomReached = false;
                    this.getTeams();
                } else {
                    this.page = 1;
                    // this.loading = true;
                    this.teams = [];
                }
            }
        },
        computed: {
            getCurrentTeamId() {
                return this.$store.state.user_info.current_team_id;
            }
        },
        methods: {
             getNameAlias(name) {
                let alias = "";
                if(name){
                    alias = name.charAt(0);
                }
                return alias;
            },
            getTeams(){
                let me = this;
                let teams = this.$store.state.teams_data;

                _.each(teams, x => {
                    me.teams.push(x);
                });
            },
            returnTeam(team) {
                this.$emit('success', team);
            },
        }
    }
</script>

<style scoped>

</style>